import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, small, Form, Input, FormGroup, InputGroup } from 'reactstrap'
import Select from 'react-select'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { selectThemeColors } from '../../../utility/Utils'
import { Eye, EyeOff, Trash } from 'react-feather'
import { setLoader, updatePassword } from './store'
import React, { useEffect, useState } from 'react'

const ChangePassword = ({ toggle2, toggle }) => {
  const dispatch = useDispatch()
  const {
    reset,
    control,
    setError,
    setValue,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({})

  const { myProfile, loader, profileLoader } = useSelector((store) => store?.MyProfile)

  const [active, setActive] = useState(true)
  const [oldPass, setOldPass] = useState(false)
  const [passToggle, setPassToggle] = useState(false)
  const setMyActiveMode = (data) => {
    setActive(!active)
  }

  const genderOption = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }]

  const handleDiscard = () => {
    // dispatch(selectProjects(null))
    reset()
    toggle()
    setLoader(false)
  }

  // const onSubmit = async (data) => {
  //  // //console.log('data', data)
  //  let formData = new FormData()
  //  if(selected !== null){
  //       formData.append('bank_name', data.bank_name)
  //       formData.append('bank_accountno', data.bank_accountno)
  //       formData.append('bank_ifsc_code', data.bank_ifsc_code)
  //       formData.append('cheque_image', data.cheque_image)
  //  }
  //  const response = await dispatch(
  //     updatePassword({ formData })
  // )
  // if (response) {
  //   reset()
  // }
  // setLoader(false)
  // }

  const onSubmit = async (data) => {
    let response = ''

    await dispatch(
      updatePassword({
        OldPassword: data.OldPassword,
        Password: data.Password,
      })
    )
    if (response) {
      reset()
      handleDiscard()
    }
  }

  return (
    <Form onSubmit={handleSubmit((data) => onSubmit(data, 'Add'))}>
      <Row >
        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="OldPassword">
            Old Password
          </Label>
          <Controller
            name="OldPassword"
            control={control}
            {...register('OldPassword', {
              required: 'Please Enter Old Password',
            })}
            render={({ field }) => (
              <InputGroup>
                 <Input
                type={oldPass ? "text":"password"}
                placeholder="Enter Old Password"
                id="OldPassword"
                // invalid={errors.OldPassword && true}
                {...field}
              />
              <span onClick={()=>setOldPass(!oldPass)} className={`input-group-text pointer`}>
                   {oldPass ?  <Eye size={10} /> : <EyeOff size={10} />}
                  </span>
                </InputGroup>

            )}
          />
          {errors && errors.OldPassword && (
            <small className='text-danger'>{errors.OldPassword.message}</small>
          )}
        </Col>

        <Col sm="6" className="mb-1" display="flex">
          <Label className="form-label" for="Password">
            New Password
          </Label>
          <Controller
            name="Password"
            control={control}
            {...register('Password', {
              required: 'Please Enter New Password',
              pattern: {
                value: /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/,
                message:
                  'Password must contain at least one letter, one number, and be at least 8 characters long.',
              },
            })}
            render={({ field }) => (
              <InputGroup>
              <Input
                type={passToggle ? "text":"password"}
                placeholder="Enter New Password"
                id="Password"
                // invalid={errors.Password && true}
                {...field}
              />
              <span onClick={()=>setPassToggle(!passToggle)} className={`input-group-text pointer`}>
                   {passToggle ?  <Eye size={10} /> : <EyeOff size={10} />}
                  </span>
                </InputGroup>
            )}
          />
          {errors && errors.Password && (
            <small className='text-danger'>{errors.Password.message}</small>
          )}
        </Col>

        <Col xs={12} className="text-center buttonWrapper mt-2">
          <Button className="me-1" color="primary" type="submit">
            Add
          </Button>
          <Button outline type="reset" onClick={handleDiscard}>
            Discard
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
export default ChangePassword